/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from 'react';
import {
  Column,
  Container,
  ContentProfile,
  Country,
  Logo,
  LogoForgotPage,
  Name,
  Photo,
  Subtitle,
  Title,
  User
} from './styles';
import logo from '../Logo/texel-logo.png'
import { Link } from 'react-router-dom';
import { TextStyled } from 'flows/base/pages/login/styles';
import { Icon, Profile } from 'components';

export default function Header(props, extraPadding) {

  const user = props.user || false;

  const [showProfile, setShowProfile] = useState(false);

  return (
    <Container>

      <Column style={{ padding: 30 }}>
        <Title>{(props.title ? props.title : "Nova Cotação")}</Title>
        {props.subtitleClickHandler &&
          <Subtitle onClick={props.subtitleClickHandler}>
            {props.subtitle ? props.subtitle : ''}
          </Subtitle>
        }
        {!props.subtitleClickHandler &&
          <Subtitle>
            {props.subtitle ? props.subtitle : ''}
          </Subtitle>
        }
        {(props.linkAnchor && props.linkText) && <Link to={props.linkAnchor} style={{ textDecoration: 'none', color: '#6CBACA' }}>{props.linkText}</Link>}
      </Column>

      {user ?
        <Column>
          <User onClick={() => setShowProfile(!showProfile)}>
            <Photo>
              <Icon name="user" />
              <Icon name="check-ok" />
            </Photo>
            <Name>{user.name}</Name>
            <Country>{user.country}</Country>
          </User>
          <ContentProfile className={showProfile ? 'profile-open' : ''}>
            <Icon name="close" className="icon-close" onClick={() => setShowProfile(false)} />
            {showProfile && <Profile user={user} />}
          </ContentProfile>
        </Column>

        : <Column style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Logo src={logo} style={{
            width: '65%',
            maxHeight: '120px',
            margin: '2rem 4px',
          }}/>
        </Column>
      }


    </Container>
  );
}
